import { put, takeEvery } from 'redux-saga/effects';
import request from 'utils/request';
import urls from 'utils/config';
import { Notify } from '@flexisaf/flexibull2';
import {
  fetchOrgBranchesSuccess,
  fetchOrgBranchesFailed,
  saveOrgBranchSuccess,
  saveOrgBranchFailed,
  editOrgBranchSuccess,
  editOrgBranchFailed,
  deleteOrgBranchSuccess,
  deleteOrgBranchFailed
} from '../actions';
import { OrganizationBranchesTypes } from '../types';
import { networkErrorHandler } from 'utils/errrorHandlers';

const { API_BASE_URL } = urls || {};

// fetch org branch
function* fetchOrgBranches({ data }) {
  const url = `${API_BASE_URL}/locations?page=${data.page}&size=${data.size}`;

  const response = yield request({
    method: 'get',
    url,
  });
  if (response.success) {
    yield put(fetchOrgBranchesSuccess(response.raw));
  } else {
    networkErrorHandler(response?.statusCode, `Failed to Fetch Organization Location(s): ${response.message}`);
    yield put(fetchOrgBranchesFailed(response.message));
  }
}

export function* fetchingOrgBranches() {
  yield takeEvery(
    OrganizationBranchesTypes.FETCHING_ORG_BRANCHES,
    fetchOrgBranches
  );
}

// save org branch
function* saveOrgBranch({ payload: { data, cb } }) {
  const url = `${API_BASE_URL}/locations`;

  const response = yield request({
    method: 'post',
    data: {
      locationDetailsList: data,
    },
    url,
  });
  if (response.success) {
    yield put(saveOrgBranchSuccess(response.raw));
    cb();
    Notify('Organization Location created successfully', {
      position: 'top-right',
      status: 'success',
    });
  } else {
    networkErrorHandler(response?.statusCode, `Failed to Save Organization Location: ${response.message}`);
    yield put(saveOrgBranchFailed(response.message));
  }
}

export function* savingOrgBranch() {
  yield takeEvery(OrganizationBranchesTypes.SAVING_ORG_BRANCH, saveOrgBranch);
}

// edit org branch
function* editOrgBranch({ payload: { data, cb } }) {
  const url = `${API_BASE_URL}/locations/${data.id}`;
  console.log('this is data', data);

  const response = yield request({
    method: 'put',
    data: {
      locationDetailsList: data.data,
    },
    url,
  });

  if (response.success) {
    yield put(editOrgBranchSuccess(response.raw));
    Notify('Organization Location updated successfully', {
      position: 'top-right',
      status: 'success',
    });
    if (cb && typeof cb === 'function') {
      cb();
    }
  } else {
    networkErrorHandler(response?.statusCode, `Failed to update Organization Location: ${response.message}`);
    yield put(editOrgBranchFailed(response.message));
  }
}

export function* edittingOrgBranch() {
  yield takeEvery(OrganizationBranchesTypes.EDITING_ORG_BRANCH, editOrgBranch);
}

// deleting org branch
function* delOrgBranch({ payload: { id, cb } }) {
  const url = `${API_BASE_URL}/locations/${id}`;

  const response = yield request({
    method: 'delete',
    url,
  });

  if (response.success) {
    yield put(deleteOrgBranchSuccess(id));
    cb();
    Notify('Organization Location deleted successfully', {
      position: 'top-right',
      status: 'success',
    });
  } else {
    networkErrorHandler(response?.statusCode, `Failed to delete Organization Location: ${response.message}`);
    yield put(deleteOrgBranchFailed(response.message));
  }
}

export function* deletingOrgBranch() {
  yield takeEvery(OrganizationBranchesTypes.DELETING_ORG_BRANCH, delOrgBranch);
}